<template>
  <div>
    <div class="head" />
    <div class="current_menu">
      <div class="content">
        <ul>
          <li v-for="(item,index) in menuList" :key="index" :class="{'active': index === activeIndex }" @click="handleSelect(index)">{{ item.title }}</li>
        </ul>
        <a class="home" @click="goHome" />
      </div>
    </div>
    <div class="company_content">
      <div class="word">
        <p class="title">{{ introductInfo.title }}</p>
        <p class="sub">{{ introductInfo.shortTitle }}</p>
        <p v-for="(item,index) in introductInfo.remarkArr" :key="index" class="text">
          {{ item }}
        </p>
      </div>
      <div class="glory">
        <img src="@/assets/images/home/history.png" alt="">
        <p class="title">{{ gloryInfo.title }}</p>
        <p class="sub">{{ gloryInfo.shortTitle }}</p>
        <p class="text">{{ gloryInfo.remark }}</p>
        <ul class="sign">
          <li><img style="width:100px;" src="@/assets/images/home/glory/xinli_logo.png" alt=""></li>
          <li><img style="width:100px;" src="@/assets/images/home/glory/high-tech.png" alt=""></li>
          <li><img style="width:100px;" src="@/assets/images/home/glory/CMMI3.png" alt=""></li>
          <li><img style="width:100px;" src="@/assets/images/home/glory/ISO.png" alt=""></li>
          <li><img style="width:100px;" src="@/assets/images/home/glory/copyright.png" alt=""></li>
        </ul>
        <ul class="honor">
          <li><img style="width:94px;" src="@/assets/images/home/glory/glory1.png" alt=""></li>
          <li><img style="width:84px;" src="@/assets/images/home/glory/glory2.png" alt=""></li>
          <li><img style="width:225px;" src="@/assets/images/home/glory/SRAI.png" alt=""></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getMainContent } from '@/plugin/api'
import { goHome } from '@/plugin/operate.js'
export default {
  data() {
    return {
      activeIndex: 0,
      menuList: [
        {
          title: '公司概况',
          id: 0
        },
        {
          title: '荣誉历程',
          id: 1
        }
      ],
      introductInfo: {},
      gloryInfo: {}
    }
  },
  mounted() {
    const params = this.$route.query
    params.tenantId = 'sft'
    this.getInfo(params)
  },
  methods: {
    goHome,
    getInfo(params) {
      getMainContent(params).then(res => {
        if (res.data.code === 200) {
          const arr = res.data.data.contentMainList[0].contentItemTreeList
          arr.forEach(item => {
            switch (item.id) {
              case 779:
                this.introductInfo = item
                this.introductInfo.remarkArr = this.introductInfo.remark.split('\n').filter(item => {
                  return item !== ''
                })
                break
              case 781:
                this.gloryInfo = item
                break
            }
          })
        }
      })
    },
    handleSelect(key) {
      const pro = document.getElementsByClassName('glory')[0].offsetTop
      switch (key) {
        case 0:
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          break
        case 1:
          window.scrollTo({
            top: pro - 120,
            behavior: 'smooth'
          })
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head{
  background-image: url('../assets/images/home/intro_bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: -310px;
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p{
    color: #fff;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  a{
    border-radius: 4px;
    color: #fff;
    border: 1px solid #fff;
    font-size: 14px;
    text-align: center;
    padding: 12px 26px;
  }
}
.company_content{
  padding: 70px 0 0 0;
  .word{
    width: 1240px;
    margin: 0 auto 100px auto;
    color: #333333;
    .title{
      font-size: 30px;
      font-weight: 800;
      margin-bottom: 10px;
    }
    .sub{
      font-size: 22px;
      margin-bottom: 65px;
    }
    .text{
      text-indent: 2em;
      line-height: 30px;
      font-size: 16px;
    }
  }
  .glory{
    position: relative;
    width: 1240px;
    padding: 50px 0 130px 0;
    margin: 0 auto;
    color: #333333;
    &>img {
      width: 720px;
      position: absolute;
      bottom: 0;
      right: 0;
    }
    .title{
      font-size: 30px;
      font-weight: 800;
      margin-bottom: 10px;
    }
    .sub{
      font-size: 22px;
      margin-bottom: 65px;
    }
    .text{
      font-size: 16px;
    }
     ul{
      display: flex;
      margin-top: 10px;
      align-items: center;
    }
    .sign{
        margin-right: 18px;
    }
    .honor{
      li{
        margin-right: 34px;
      }
    }
  }
}
</style>
